import React from 'react';
import styles from './WorldCupGroups.module.css';
import { getFlagUrl } from '../../../server/services/custom-pages/worldcupFlags';

function GroupTable({ label, teams }) {
  return (
    <div className={styles.groupCard}>
      <span className={styles.groupLabel}>{label}</span>
      <div className={styles.groupTeamsList}>
        {/* Header */}
        <div className={styles.groupTeamRow}>
          <div className={styles.groupTeamLeftInfoHeader}>
            <span className={styles.groupTeamPos}>#</span>
            <span className={styles.groupTeamName} style={{ fontWeight: 'bold' }}>Country</span>
          </div>
          <span className={styles.groupStatHeaderW}>W</span>
          <span className={styles.groupStatHeaderG}>GD</span>
          <span className={styles.groupStatHeaderP}>Pts</span>
        </div>
        {teams.map((team, idx) => {
          // Extract data from API response structure (team is a participant object)
          const teamName = team.name;
          const teamId = team.id;
          const rank = team.rank;
          
          // Extract stats from the columns array
          const getColumnValue = (code) => {
            const column = team.columns?.find(col => col.code === code);
            return column?.value;
          };
          
          const mpVal = getColumnValue('mp');
          const matchesPlayed = mpVal !== undefined && mpVal !== null ? Number(mpVal) : 0;
          const wins = getColumnValue('won');
          const goalsDiff = getColumnValue('goals_diff');
          const points = getColumnValue('pts');
          const flagUrl = getFlagUrl(teamName);

          const hasPlayed = matchesPlayed > 0;
          const displayWins = (hasPlayed && wins !== undefined && wins !== null) ? wins : '-';
          const displayGoalsDiff = (hasPlayed && goalsDiff !== undefined && goalsDiff !== null) ? (Number(goalsDiff) > 0 ? `+${goalsDiff}` : goalsDiff) : '-';
          const displayPoints = (hasPlayed && points !== undefined && points !== null) ? points : '-';

          return (
            <div key={teamId} className={styles.groupTeamRow}>
              <div className={styles.groupTeamLeftInfo}>
                <span className={styles.groupTeamPos}>#{rank}</span>
                {flagUrl && (
                  <img src={flagUrl} alt={teamName} className={styles.groupTeamFlag} loading="lazy" />
                )}
                <span className={styles.groupTeamName}>{teamName}</span>
              </div>
              <span className={styles.groupStatValW}>{displayWins}</span>
              <span className={styles.groupStatValG}>{displayGoalsDiff}</span>
              <span className={styles.groupStatValP}>{displayPoints}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function WorldCupGroups({ groups }) {
  if (!groups || groups.length === 0) {
    return (
      <div className={styles.groupSectionContainer}>
        <h2 className={styles.groupSectionHeading}>Group Tables</h2>
        <div className={styles.groupFullDivider} />
        <p className={styles.groupStatusMsg}>Group standings are currently unavailable.</p>
      </div>
    );
  }

  return (
    <div className={styles.groupSectionContainer}>
      <h2 className={styles.groupSectionHeading}>Group Tables</h2>
      <div className={styles.groupFullDivider} />
      <div className={styles.groupsGrid}>
        {groups.map((group) => (
          <GroupTable 
            key={group.id || group.name} 
            label={group.name} 
            teams={group.participants} 
          />
        ))}
      </div>
    </div>
  );
}
